export default class ErrorHigia {
    private static instance: ErrorHigia
    public status: number
    public statusText: string
    public path: string
    public mensagemHg: string
    public tituloHg: string
    public codTipoErroHg: number
    public descTipoErroHg: string
    public timestamp: string

    /**Campo legado para apagar apos a finalização de tratamento de erros() e evolução das telas */
    public mensagemRetorno: any

    /**
     * Método estático que controla o acesso à única instância do DTO
     *
     */
    public static getInstance(
        status: number,
        statusText: string,
        path: string,
        mensagemHg: string,
        tituloHg: string,
        codTipoErroHg: number,
        descTipoErroHg: string,
        timestamp: string,
        mensagemRetorno: any
    ): ErrorHigia {
        if (!ErrorHigia.instance) {
            ErrorHigia.instance = new ErrorHigia(
                status,
                statusText,
                path,
                mensagemHg,
                tituloHg,
                codTipoErroHg,
                descTipoErroHg,
                timestamp,
                mensagemRetorno
            )
        }
        return ErrorHigia.instance
    }

    constructor(
        status: number,
        statusText: string,
        path: string,
        mensagemHg: string,
        tituloHg: string,
        codTipoErroHg: number,
        descTipoErroHg: string,
        timestamp: string,
        mensagemRetorno?: any
    ) {
        this.status = status
        this.statusText = statusText
        this.path = path
        this.mensagemHg = mensagemHg
        this.tituloHg = tituloHg
        this.codTipoErroHg = codTipoErroHg
        this.descTipoErroHg = descTipoErroHg
        this.timestamp = timestamp

        /**Campo legado para apagar apos a finalização de tratamento de erros() e evolução das telas */
        this.mensagemRetorno = mensagemRetorno
    }
}
